<template>
  <div class="tipo">
    <div class="centro">
      <h1><span>Consulta por Órgão de Atos Infralegais</span></h1>
      <BuscaSimplesCards titulo="Consultas Rápidas" :cards="cards" />
      <Loading v-if="carregando" />
      <ErroResultados v-if="!carregando && erro" />
      <PainelBuscaSimplificada
        :dados="orgaosFormatados"
        :generateUrl="generateUrl"
        titulo="Órgãos"
        v-if="!carregando && !erro"
      />
    </div>
  </div>
</template>

<script>
import LegislacaoMunicipalApi from "@/services/LegislacaoMunicipalApi";
import Loading from "@/components/Loading";
import ErroResultados from "@/components/ErroResultados";
import PainelBuscaSimplificada from "@/components/PainelBuscaSimplificada";
import BuscaSimplesCards from "@/components/BuscaSimplesCards.vue";

export default {
  name: "AtosInfralegaisPorEnteFederativoPorOrgao",
  props: {
    slug: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      carregando: true,
      erro: false,
      orgaos: [],
      filtro: {
        orgao: [],
        ano: null,
      },
      enteFederativoId: null,
    };
  },
  computed: {
    orgaosFormatados() {
      return this.orgaos.map((orgao) => {
        return {
          id: orgao.id,
          nome: orgao.nome,
          quantidade_total: orgao.quantidade_total,
        };
      });
    },
    cards() {
      return [
        {
          rota: { name: "AtosInfralegaisPorEnteFederativoPorTipo", params: { slug: this.slug } },
          icone: require("@/assets/images/icon-tipo-legislacao2.png"),
          iconeClasse: "legisla-icon",
          titulo: "Tipo de Ato",
          descricao: "Consulte os Atos Infralegais<br /> por <strong>tipo</strong>",
        },
         {
          rota: { name: "AtosInfralegaisPorEnteFederativoPorOrgao", params: { slug: this.slug } },
          icone: require("@/assets/images/orgao-atos-icon-min2.png"), // Supondo que você tenha um ícone para órgão
          iconeClasse: "legisla-icon",
          titulo: "Órgão",
          descricao: "Consulte os Atos Infralegais<br /> por <strong>órgão</strong>",
        },
        {
          rota: { name: "AtosInfralegaisPorEnteFederativoPorAno", params: { slug: this.slug } },
          icone: require("@/assets/images/icon-indice-cronologico2.png"),
          iconeClasse: "indice-icon",
          titulo: "Índice Cronológico",
          descricao: "Consulte os Atos Infralegais<br /> por <strong>ano</strong>",
        },
      ];
    },
  },
  components: {
    PainelBuscaSimplificada,
    Loading,
    ErroResultados,
    BuscaSimplesCards,
  },
  created() {
    this.legislacaoApi = new LegislacaoMunicipalApi();
    this.findEnteFederativoAndLoadOrgaos();
  },
  methods: {
    findEnteFederativoAndLoadOrgaos: async function () {
      try {
        const allEntesFederativos = await this.legislacaoApi.getEntesFederativos();
        const enteFederativo = allEntesFederativos.find(ente => ente.slug === this.slug);

        if (!enteFederativo) {
          this.erro = true;
          this.carregando = false;
          return;
        }
        this.enteFederativoId = enteFederativo.id;
        this.carregarOrgaos();
      } catch (err) {
        console.log("findEnteFederativoAndLoadOrgaos", err);
        this.erro = true;
        this.carregando = false;
      }
    },
    carregarOrgaos: async function () {
      try {
        if (this.legislacaoApi.cancelTokens.getOrgaosAtosInfralegais) {
          this.legislacaoApi.cancelTokens.getOrgaosAtosInfralegais.cancel();
        }

        this.carregando = true;
        this.erro = false;
        this.orgaos = await this.legislacaoApi.getOrgaosAtosInfralegais(this.enteFederativoId);
        console.log("Dados da API para órgãos de atos infralegais:", this.orgaos);
        this.carregando = false;
      } catch (err) {
        if (this.legislacaoApi.isCancel(err)) {
          return;
        }
        console.log(err);
        this.erro = true;
        this.carregando = false;
      }
    },
    generateUrl(ano, dados) {
      this.filtro.orgao.push(dados.id);
      this.filtro.ano = ano;

      this.$router.push({
        name: "AtosInfralegaisPorEnteFederativo",
        params: { slug: this.slug },
        query: {
          ...this.filtro,
          pagina: 1,
          qtd_por_pagina: 10,
          busca_avancada: 1,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
h1 span{
  background-color: #ffb24e;
  width: fit-content;
  border-radius: 12px;
  color: #0e489f;
  font-size: 1.5rem;
  padding: 0 0.3rem;
  margin: 2rem 0rem 1.5rem 0.5rem;
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;/* limita o fundo ao tamanho do texto */
}
.tipo {
  min-height: calc(100vh - 10rem);
  margin-bottom: 5rem;
}
</style>
